<script>
export default {
  name: 'ArtistAvatarCarousel',
  props: {
    artistId: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      items: [],
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      fits: ['fill']//'contain', 'cover', 'none', 'scale-down'
    }
  },
  methods: {
    async getArtistInfo() {
      this.items = await this.$api.getArtistAvatars(this.artistId)
    }
  },
  created() {
    this.getArtistInfo()
  }
}
</script>

<template>
  <div style='text-align: center'>
    <el-carousel trigger='click' height='120px' direction="vertical" :autoplay="false">
      <el-carousel-item v-for='(url, index) in items' :key='index'>
        <el-avatar shape='circle' :size='100' fit='fill' :src='url'></el-avatar>
      </el-carousel-item>
    </el-carousel>
  </div>

</template>

<style scoped>

</style>
